/** Words in the owner's home-page switcher (only an admin account ever sees these). */
import type { HomeHeadline, HomeLayout, HomeSkin } from "./siteSettings";

export const LAYOUT_NAMES: Record<HomeLayout, { name: string; note: string }> = {
  flagship: { name: "Flagship (R)", note: "today's home page" },
  simple: { name: "Simple", note: "one headline, one Upload bar" },
  w: { name: "W · App first", note: "the phone app is the main ask" },
  y: { name: "Y · The sheet", note: "a working clip list up top" },
  z: { name: "Z · The app", note: "the site works like the app" },
};

export const SKIN_NAMES: Record<HomeSkin, string> = { cream: "Cream", red: "Red", dark: "Dark" };

/** Short names for the headline buttons; the full lines are in simpleHomeText.ts. */
export const HEADLINE_NAMES: Record<HomeHeadline, string> = {
  becomes: "…becomes a clip",
  is: "…is a clip",
  cut: "Already cut",
  cherries: "Its cherries",
};

export const SWITCHER = {
  pill: "Home page",
  title: "Home page",
  everyone: "Everyone sees",
  you: "You're looking at",
  onlyYou: "preview, only you see this",
  skin: "Colors",
  headline: "Headline",
  makeLive: "Make this live for everyone",
  backToLive: "Back to the live one",
  saving: "Saving…",
  confirm: (what: string) => `Everyone who opens the site will now see ${what}. Go ahead?`,
  saved: (what: string) => `Live for everyone: ${what}`,
  failed: "Couldn't save. Try again.",
  close: "Close",
};

export const describe = (layout: HomeLayout, skin: HomeSkin) =>
  layout === "simple" ? `${LAYOUT_NAMES[layout].name} · ${SKIN_NAMES[skin]}` : LAYOUT_NAMES[layout].name;

export const describeFull = (layout: HomeLayout, skin: HomeSkin, headline: HomeHeadline) =>
  layout === "simple" ? `${describe(layout, skin)} · ${HEADLINE_NAMES[headline]}` : describe(layout, skin);
